import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="px-6 mt-27 py-12 max-w-5xl mx-auto text-black bg-white">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Privacy Policy
      </h1>

      <p className="mb-6">
        Last updated: [Insert Date]
      </p>

      <p className="mb-6">
        At The Great Honey Co. (“we”, “our”, “us”), your privacy is our priority. This Privacy Policy explains how we collect, use, and share your personal information when you visit our website, <a className="underline" href="https://www.thegreathoneyco.com/">https://www.thegreathoneyco.com/</a>, or purchase our products. By using our website, you agree to the practices described in this policy.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">1. Information We Collect</h2>

      <h3 className="text-xl font-semibold mb-2">A. Device Information</h3>
      <ul className="list-disc ml-6 mb-4 space-y-2">
        <li>Browser and Device Data: Your web browser type, device type, IP address, and time zone.</li>
        <li>Usage Data: Information about the pages you view, search terms, and how you interact with our website.</li>
        <li>Tracking Technologies:
          <ul className="list-disc ml-6 space-y-1 mt-1">
            <li><strong>Cookies:</strong> Small data files stored on your device. Learn more at All About Cookies.</li>
            <li><strong>Log Files:</strong> Record details like IP address, ISP, browser type, access time, and referring pages.</li>
            <li><strong>Web Beacons, Pixels, Tags:</strong> Used for site navigation analysis.</li>
          </ul>
        </li>
      </ul>

      <h3 className="text-xl font-semibold mb-2">B. Order Information</h3>
      <ul className="list-disc ml-6 mb-6 space-y-2">
        <li>Personal Data: Your name, addresses, email, and phone number.</li>
        <li>Payment Data: Payment details required for processing.</li>
        <li>Order Details: Products you purchase.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">2. How We Use Your Information</h2>
      <ul className="list-disc ml-6 mb-6 space-y-2">
        <li>Process Orders</li>
        <li>Customer Communication</li>
        <li>Fraud Prevention</li>
        <li>Enhance User Experience</li>
        <li>Marketing (with opt-out option)</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">3. Sharing Your Information</h2>
      <ul className="list-disc ml-6 mb-6 space-y-2">
        <li>Service Providers (e.g., shipping, analytics, marketing)</li>
        <li>Legal Compliance</li>
        <li>Analytics tools like Google Analytics</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">4. Behavioral Advertising</h2>
      <p className="mb-6">
        We may use your Personal Information for targeted ads. Learn more at Network Advertising Initiative or Digital Advertising Alliance.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">5. Do Not Track</h2>
      <p className="mb-6">
        Our site doesn’t currently respond to Do Not Track signals.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">6. Data Retention</h2>
      <p className="mb-6">
        We retain Order Information for record-keeping unless you request deletion.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">7. Changes to This Privacy Policy</h2>
      <p className="mb-6">
        We may update this policy from time to time. Updates will be posted on this page.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">8. Contact Us</h2>
      <p className="mb-2">
        For questions or concerns:
      </p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Email: <a className="underline" href="mailto:hello@thegreathoneyco.com">hello@thegreathoneyco.com</a></li>
        <li>Phone: 863-954-2319</li>
        <li>Contact form available on the website</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
